import * as React from 'react'
import { CompanyGroupModel } from '../../../types/companyGroups'
import { faChevronRightSolid, FaIcon } from '@/lib/fa'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { CompanyIcon } from '@/app/features/icons/Company'

interface EditCompanyGroupsDefaultListProps {
  setSelectedGroup: (group: CompanyGroupModel) => void
}

const EditCompanyGroupsDefaultList: React.FC<EditCompanyGroupsDefaultListProps> = ({
  setSelectedGroup,
}) => {
  const { t } = useLocalize()
  const defaultGroups: CompanyGroupModel[] = [
    { id: -1, name: t('addCompany.activeCompanies') },
    { id: -2, name: t('addCompany.inactiveCompanies') },
  ]

  return (
    <div>
      <div className="tw-bg-gray-100 tw-px-4 tw-pb-1.5 tw-pt-2.5 tw-text-xs tw-font-medium tw-uppercase tw-text-content-base/80">
        {t('addCompany.default')}
      </div>
      <div className="tw-flex tw-flex-col">
        {defaultGroups.map((group) => (
          <div
            key={group.id}
            onClick={() => setSelectedGroup(group)}
            className="tw-flex tw-cursor-pointer tw-items-center tw-justify-between tw-gap-4 tw-border-t tw-border-base-300 tw-px-2 tw-py-4 hover:tw-bg-gray-100"
          >
            <div className="tw-text-medium tw-flex tw-items-center tw-gap-2 tw-text-content-base">
              <CompanyIcon className="tw-h-4 tw-w-4" />
              <p>{group.name}</p>
            </div>
            <FaIcon icon={faChevronRightSolid} className="tw-z-5 tw-h-5" />
          </div>
        ))}
      </div>
    </div>
  )
}

export default EditCompanyGroupsDefaultList
